function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledLiveBoardTabComponent } from "./live-board-tab-component.scss";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import FlexibleCardsGridComponent from "segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-component";
import { ALIGN_TYPES } from "constants/align-types";
import classnames from "classnames";
import AssetComponent from "/components/core/asset/asset-component";
const LiveBoardTabComponent = (props)=>{
    const { description, topAssetProps, gridItems, hideCardParagraph, onCardClick, hideVideoControls, onAssetClick } = props;
    return /*#__PURE__*/ _jsx(StyledLiveBoardTabComponent, {
        className: classnames("live-board-tab-wrapper", {
            "hide-paragraph": hideCardParagraph
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "tab-content",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "description-wrapper",
                    children: /*#__PURE__*/ _jsx(Paragraph, {
                        body: description
                    })
                }),
                topAssetProps && /*#__PURE__*/ _jsx("div", {
                    className: "asset-wrapper",
                    onClick: onAssetClick,
                    children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, topAssetProps), {
                        hideControls: hideVideoControls
                    }))
                }),
                gridItems === null || gridItems === void 0 ? void 0 : gridItems.map((item)=>/*#__PURE__*/ _jsx("div", {
                        className: "tab-cards-wrapper",
                        children: /*#__PURE__*/ _jsx(FlexibleCardsGridComponent, {
                            gridItems: item,
                            gridAlignment: ALIGN_TYPES.CENTER,
                            defaultCardClick: onCardClick
                        })
                    }))
            ]
        })
    });
};
export default LiveBoardTabComponent;
